export enum Roles {
    SUPERUSUARIO = "SUPERUSUARIO", 
    VERSERVICIOALCLIENTE = "VERSERVICIOALCLIENTE",
    VERADMINISTRACIONDEUSUARIO = "VERADMINISTRACIONDEUSUARIO",
    VERADMINISTRACIONDECONTENIDO = "VERADMINISTRACIONDECONTENIDO",
    VERADMINISTRACIONFICHADEPRODUCTO = "VERADMINISTRACIONFICHADEPRODUCTO",
    VERLOGDEEVENTOS = "VERLOGDEEVENTOS",
    VERPEDIDOS = "VERPEDIDOS",
    VERFACTURACIONYPAGO = "VERFACTURACIONYPAGO",
    VERCARTOLADEMOVIMIENTO = "VERCARTOLADEMOVIMIENTO",
    VERPRODUCTOS = "VERPRODUCTOS",
    VERADMINISTRACIONDEPERFIL = "VERADMINISTRACIONDEPERFIL",
    VERADMINISTRACIONDEEMPRESAS = "VERADMINISTRACIONDEEMPRESAS",
    VENDEDOR = "VENDEDOR"
}